export interface NovelGroup {
  groupId: string;
  name: string;
  novelKeys: string[];
  createdAt: string;
  updatedAt: string;
}

export interface NovelGroupSummary {
  groupId: string;
  name: string;
}
